import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import cookie from 'js-cookie';
import Loading from '../Loading';
import './ContactAndShipping.scss';

const EditLink = props => {
  if (props.fieldType === 'contact' && !!cookie.get('restricted_user_id')) {
    return null;
  }
  return (
    <p className="contact-and-shipping__edit-link">
      <a
        href={props.url}
        data-field-type={props.fieldType}
        onClick={props.onClick}>
        {props.cta}
      </a>
    </p>
  );
};

const ContactAndShipping = props => {
  if (props.isLoading) {
    return <Loading dark relative small />;
  }
  return (
    <section className={cx('contact-and-shipping', {
      'contact-and-shipping--vertical-layout': props.isVerticalLayout
    })}>
      {props.items.map((item, key) => {
        return (
          <div
            key={`${item.label}-${key}`}
            className="contact-and-shipping__content">
            <div>
              <p className="contact-and-shipping__content-title">{item.label}</p>
              <p className="contact-and-shipping__shipping-details">{item.content}</p>
            </div>
            <EditLink
              {...item}
              cta={props.editLinkText}
              onClick={props.handleOnClick}
            />
          </div>
        );
      })}
    </section>
  );
};

EditLink.propTypes = {
  fieldType: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

ContactAndShipping.propTypes = {
  editLinkText: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired
  })).isRequired,
  country: PropTypes.object,
  handleOnClick: PropTypes.func.isRequired,
  isVerticalLayout: PropTypes.bool,
};

export default ContactAndShipping;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ContactAndShipping/ContactAndShipping.js